<div class="container-fluid testimonials2-container py-5">
  <!-- Title and Subtitle (same format as sblock-location__title) -->
  <div *ngIf="title || subtitle" class="container">
    <header class="sblock-testimonials2__head mb-4">
      <h2
        *ngIf="title"
        class="sblock-testimonials2__title"
        [ngStyle]="{ color: titlesColor ? titlesColor : '' }"
        [ngClass]="{ 'cursor-pointer': hasTitleLink() }"
        (click)="gotToLink()"
        [innerHTML]="title | safeHtml"
      ></h2>
      <span
        *ngIf="subtitle"
        class="sblock-testimonials2__eyebrow"
        [ngStyle]="{ color: secondaryColor ? secondaryColor : '' }"
        [innerHTML]="subtitle | safeHtml"
      ></span>
    </header>
  </div>

  <!-- Skeleton while loading -->
  <div *ngIf="loading" class="container">
    <div class="cards-row">
      <div class="testimony-card" *ngFor="let s of skeletonCards">
        <div class="card-header">
          <div class="author-avatar skeleton skeleton--circle"></div>
          <div class="author-info" style="flex: 1">
            <div class="skeleton skeleton--text skeleton--line-60"></div>
            <div class="skeleton skeleton--text skeleton--line-40"></div>
          </div>
        </div>
        <div class="skeleton skeleton--text"></div>
        <div class="skeleton skeleton--text skeleton--line-80"></div>
      </div>
    </div>
  </div>

  <!-- Slider with side arrows -->
  <div *ngIf="!loading && testimonials && testimonials.length > 0" class="testimonials2-slider">
    <button
      *ngIf="totalPages > 1"
      type="button"
      class="side-arrow side-arrow--prev"
      (click)="prevSlide()"
      aria-label="Previous"
    >
      <i class="fa fa-arrow-left"></i>
    </button>

    <div class="slider-viewport">
      <div class="slider-track" [style.transform]="'translateX(-' + (pageIndex * 100) + '%)'">
        <div *ngFor="let page of pages; let p = index" class="slide-page">
          <div class="cards-row">
            <div
              *ngFor="let testimony of page"
              class="testimony-card"
            >
              <!-- Quote icon top-right -->
              <img
                class="quote-icon"
                src="assets/images/quotes.png"
                alt=""
                aria-hidden="true"
              />

              <!-- Header: avatar + name/position/stars -->
              <div class="card-header">
                <div class="author-avatar">
                  <img
                    [src]="getImage(testimony)"
                    [alt]="testimony.name || ''"
                    onError="this.src='assets/images/empty_user.png'"
                    loading="lazy"
                  />
                </div>
                <div class="author-info">
                  <div class="author-name">{{ testimony.name }}</div>
                  <div
                    *ngIf="testimony.position"
                    class="author-position"
                  >
                    {{ testimony.position }}
                  </div>
                  <div class="stars" [style.color]="primaryColor">
                    <i *ngFor="let s of stars(testimony)" class="fa fa-star"></i>
                    <i *ngFor="let s of emptyStars(testimony)" class="fa fa-star-o"></i>
                  </div>
                </div>
              </div>

              <!-- Description -->
              <div class="card-description">{{ testimony.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      *ngIf="totalPages > 1"
      type="button"
      class="side-arrow side-arrow--next"
      (click)="nextSlide()"
      aria-label="Next"
    >
      <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>
